import React from "react"
import PropTypes from "prop-types"

const NavBarLogo = props =>
    <div
        className="nav-bar-logo"
        style={{ backgroundImage: `url("${props.image_url}")` }}
    />

NavBarLogo.propTypes = {
    image_url: PropTypes.string,
}

NavBarLogo.defaultProps = {
    image_url: '',
}

export default NavBarLogo
